import React, { useEffect, useState } from 'react';
import { StyledUserInfoContainer, StyledUserInfoWrapper, StyledUserInfo, StyledWalletInfo, StyledUserImageWrapper, StyledUserAddress, StyledButtonWrapper } from './TopPlayer.styled';
import ProfileImage from "../../../assets/images/profile.png"
import { getUserInfo } from '../../../utils/getUserInfo';

interface Props {
    walletAddress: string | null
    place: string
    tokenWon: number | null
}

const TopPlayer = (props: Props) => {
    const [userData, setUserData] = useState<any>(null);
    const [createdAt, setCreatedAt] = useState<string>("");

    useEffect(() => {
        const getUser = async () => {
            if (props.walletAddress == null) {
                return;
            }
            const res = await getUserInfo(props.walletAddress);
            if (res?.status) {
                setUserData(res.userData);
                if(res.userData == undefined) return;
                const date = new Date(res.userData.created_at);
                const month = date.toLocaleString('en-US', { month: 'long' });
                const year = date.getFullYear();
                setCreatedAt(`Member since ${month} ${year}`)
            } else {
                setUserData(null)
            }
        }

        if (props.walletAddress != null) {
            getUser();
        }
    }, [props.walletAddress])

    return (
        <StyledUserInfoContainer>
            <StyledUserInfoWrapper>
                <StyledUserImageWrapper>
                    <img src={userData == null || userData.avatar == "" ? ProfileImage : `${process.env.REACT_APP_API_ENDPOINT}${userData.avatar}`} alt="banner image" crossOrigin="anonymous" />
                </StyledUserImageWrapper>
                <StyledUserInfo>
                    <StyledUserAddress>{`${userData ? userData?.walletAddress.slice(0, 4) : "xxxx"}...${userData ? userData.walletAddress.slice(-4) : "xxxx"}`}</StyledUserAddress>
                    <h5 style={{ color: 'white', opacity: '0.5', fontSize: '12px', margin: '0', fontWeight: '400' }}>{createdAt}</h5>
                    <StyledWalletInfo>
                        <div>
                            <StyledUserAddress>{props.place} Place</StyledUserAddress>
                            <h5 style={{ color: 'white', opacity: '0.5', fontSize: '12px', margin: '0', fontWeight: '400' }}>Last 24 hours</h5>
                        </div>
                        <div>
                            <h5 style={{ color: 'white', opacity: '0.5', fontSize: '12px', margin: '0', fontWeight: '400' }}>Token Won</h5>
                            <h2 style={{ color: 'white', fontSize: '14px', margin: '0', fontWeight: '400' }}>{props.tokenWon ? props.tokenWon / 1000 : 0} Sol</h2>
                        </div>
                    </StyledWalletInfo>
                </StyledUserInfo>
            </StyledUserInfoWrapper>
        </StyledUserInfoContainer>
    );
}

export default TopPlayer;
